export const ADD_CUSTOMER_FORM_CHANGE = 'ADD_CUSTOMER_FORM_CHANGE';
export const ADD_CUSTOMER_FORM_CLEAR = 'ADD_CUSTOMER_FORM_CLEAR';

export const SET_CUSTOMER_LIST = 'SET_CUSTOMER_LIST';